import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import normalizeError from './normalizeError'

const { mode, sentryMode, prodSentryDsn, defaultSettings: defaultTerminalSettings } = window.PROJECT_CONFIG
const { prodSentryDsn: prodDefaultSentryDsn } = defaultTerminalSettings
// 监控
// https://github.com/getsentry/sentry-javascript/tree/master/packages/react/
// https://docs.sentry.io/platforms/javascript/guides/react/

export const init = () => {
    if (mode === 'dev') {
        return
    }

    Sentry.init({
        // tower 没有 所以是 默认
        dsn: prodDefaultSentryDsn || prodSentryDsn,
        autoSessionTracking: true,
        sendClientReports: false,
        integrations: [
            new Integrations.BrowserTracing({
                beforeNavigate: context => {
                    return {
                        ...context,
                        // You could use your UI's routing library to find the matching
                        // route template here. We don't have one right now, so do some basic
                        // parameter replacements.

                        name: decodeURIComponent(location.pathname)
                            .replace(/\/[A-Z0-9]{32}/g, '/<hash>')
                            .replace(/\/\d+/g, '/<digits>')
                            .replace(/\/goodsRelease\/[\u4e00-\u9fa5]+/g, '/goodsRelease/<shopType>')
                    }
                }
            })
        ],
        tracesSampleRate: 1.0,
        release: window.APP_VERSION,
        dist: window.APP_VERSION,
        // dev test uat prod
        environment: sentryMode || mode,
        // why ignore ResizeObserver loop limit exceeded
        // https://github.com/Ensembl/ensembl-client/commit/ffa4908d195897c17b5013754be3d013836e2fe3
        // https://github.com/WICG/resize-observer/issues/38#issuecomment-422126006
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
            'Failed to fetch',
            'injectJsCode'
        ],
        denyUrls: [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i, /^safari-extension:\/\//i],
        beforeSend: event => {
            // 获取当前事件中的请求信息
            const request = event.request
            if (request) {
                // 处理URL参数
                const url = request.url && new URL(request.url)
                const referer = request.headers?.Referer ? new URL(request.headers.Referer) : ''

                const deleteKeys = ['t', 'eTicket', 'token', 'access_token', 'simple_token', '_gt']

                // 过滤特定参数
                deleteKeys.forEach(v => {
                    if (url) {
                        url.searchParams.delete(v)
                    }
                    if (referer) {
                        referer.searchParams.delete(v)
                    }
                })

                // 更新事件中的URL
                if (url) {
                    request.url = url.toString()
                }
                if (referer) {
                    request.headers.Referer = referer.toString()
                }
            }

            return event // 返回修改后的事件
        }
    })
}

// 构建异常
function buildException(exception) {
    return normalizeError(exception)
}

interface ContextType {
    anchor?: string
    extra: any
    mustNotify?: boolean
}

// 构建上下文
const buildContext = (props: ContextType) => {
    const { anchor, extra, mustNotify } = props || {}
    const tags: any = {
        anchor: anchor || '123456'
    }
    if (mustNotify) {
        tags.mustNotify = 1
    }
    return {
        tags,
        extra
    }
}

/*
 * 约定: 通过tags传输查询标记，主动上报需记录anchor
 * anchor 为唯一key
 * */

// 捕获错误
export const captureException = (exception: string, context: ContextType) => {
    const e = buildException(exception)
    const c = buildContext(context)

    Sentry.captureException(e, c)
}

// 报告消息
export const captureMessage = (message, context) => {
    const c = buildContext(context)

    Sentry.captureMessage(message, c)
}
